(() => {
  const root = document.querySelector('[data-dalineo-apple]');
  if (!root) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = root.querySelectorAll('[data-apple-reveal]');

  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    revealItems.forEach((item) => observer.observe(item));
  }

  const hero = root.querySelector('.dalineo-apple-hero');
  const heroMedia = root.querySelector('[data-apple-hero-media]');
  if (!hero || !heroMedia || reducedMotion || window.matchMedia('(max-width: 749px)').matches) return;

  let ticking = false;
  const updateHero = () => {
    const rect = hero.getBoundingClientRect();
    const progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
    heroMedia.style.setProperty('--da-hero-shift', `${progress * 3.5}rem`);
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHero);
  }, { passive: true });
})();
